/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import toast from '@/services/toast';
export default {
  name: 'user-activity-for-team',
  components: {},
  props: [],
  data () {
    return {
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      DeleteId:'',
      checkDataTaskModal:false,
      userTaskList:{},
      userTaskListResults:[],
      userInfoByTeamHead:null,
      userAIResults:[]
    }
  },
  computed: {
  ...mapGetters([
    'getUserActivityByIDOfTeamHeadGetters',
    'getUserInfoByIdForTeamHeadGetters'
  ]),
  getUserTaskListedFun(){
    return this.userTaskList = this.$store.getters.getUserActivityByIDOfTeamHeadGetters.data
  },
  getUserInfoByIdFun() {
    this.userInfoByTeamHead = this.$store.getters.getUserInfoByIdForTeamHeadGetters.data
    return
  },
  SetIntialStatus() {
    if (this.userTaskList != undefined) {
      this.userTaskListResults = this.userTaskList.algo_data
      this.userAIResults = this.userTaskList.model_data
    }
  }
  },
  mounted () {
    this.getUserTaskListedFun
    this.getUserInfoByIdFun
    this.SetIntialStatus
  },
  methods: {
  },
  watch:{
    getUserTaskListedFun(){
      return this.userTaskList = this.$store.getters.getUserActivityByIDOfTeamHeadGetters.data
    },
    SetIntialStatus() {
      if (this.userTaskList != undefined) {
        this.userTaskListResults = this.userTaskList.algo_data
        this.userAIResults = this.userTaskList.model_data
      }
    },
    getUserInfoByIdFun() {
      return this.$store.getters.getUserInfoByIdForTeamHeadGetters
    }
  }
}